import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import FigmaNavigation from '../components/FigmaNavigation';
import Footer from '../components/shared/Footer';

const FigmaProductDetail = () => {
  const navigate = useNavigate();
  const { productType } = useParams();
  const [quantity, setQuantity] = useState(0);
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  // Get product data based on route
  const getProductData = () => {
    if (productType === 'lipoderma') {
      return {
        name: 'Lipoderma™',
        sku: '2,51,594',
        price: 650.00,
        rating: 5,
        reviewCount: 4,
        images: [
          '/UnisynHub/Assets/lipoderma-card.png',
          '/UnisynHub/Assets/lipoderma-card.png',
          '/UnisynHub/Assets/lipoderma-card.png',
          '/UnisynHub/Assets/lipoderma-card.png'
        ],
        pricingTiers: [
          { range: '1-9 Vials', price: '$650/ea' },
          { range: '10-29 Vials', price: '$550/ea' },
          { range: '30+ Vials', price: '$500/ea' }
        ],
        sizing: '1.5 mL Vial',
        shipping: 'Cryopreserved, shipped Next-Day on dry ice.',
        description: 'Lipoderma™ is a native structural adipose allograft—a first-of-its-kind, off-the-shelf solution designed to restore volume where natural fat loss occurs. Unlike synthetic fillers, Lipoderma™ retains the biological and structural properties of real adipose tissue, promoting natural-looking results that integrate seamlessly with the patient\'s body.',
        features: [
          'FDA 361-compliant adipose tissue allograft',
          'Off-the-shelf with biological integrity',
          'Minimally invasive, in-office application',
          'Ideal bridge between injectables and surgery'
        ],
        additionalInfo: 'Cras et diam maximus, accumsan sapien et, sollicitudin velit. Nulla blandit eros non turpis lobortis iaculis at ut massa.',
        category: 'Aesthetics'
      };
    } else if (productType === 'equicent') {
      return {
        name: 'equicent™ CTM',
        sku: '2,51,595',
        price: 450.00,
        rating: 5,
        reviewCount: 6,
        images: [
          '/UnisynHub/Assets/equicenta-card.png',
          '/UnisynHub/Assets/equicenta-card.png',
          '/UnisynHub/Assets/equicenta-card.png',
          '/UnisynHub/Assets/equicenta-card.png'
        ],
        pricingTiers: [
          { range: '1-9 Vials', price: '$450/ea' },
          { range: '10-29 Vials', price: '$380/ea' },
          { range: '30+ Vials', price: '$350/ea' }
        ],
        sizing: '5 mL Vial',
        shipping: 'Cryopreserved, shipped Next-Day on dry ice.',
        description: 'equicent™ CTM is an advanced umbilical cord tissue therapy specifically designed for equine regenerative medicine. This cutting-edge treatment provides superior healing properties for ligament injuries, joint health, and soft tissue regeneration in horses.',
        features: [
          'Advanced umbilical cord tissue therapy',
          'Proven results for equine athletes',
          'Minimally invasive treatment protocol',
          'Enhanced healing and recovery'
        ],
        additionalInfo: 'Advanced regenerative therapy designed specifically for equine athletes and performance horses.',
        category: 'Equine Medicine'
      };
    }
    return null;
  };

  const product = getProductData();
  
  if (!product) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <FigmaNavigation />
        <div style={{ 
          flexGrow: 1, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          fontFamily: 'Poppins, sans-serif'
        }}>
          <div style={{ textAlign: 'center' }}>
            <h1 style={{ color: '#1a1a1a', marginBottom: '16px' }}>Product Not Found</h1>
            <button 
              onClick={() => navigate('/products')}
              style={{
                padding: '14px 32px',
                backgroundColor: '#039582',
                color: 'white',
                border: 'none',
                borderRadius: '43px',
                fontSize: '16px',
                fontFamily: 'Poppins, sans-serif',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Browse Products
            </button>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  const primaryColor = productType === 'equicent' ? '#5c725c' : '#039582';

  const handleQuantityChange = (change) => {
    setQuantity(Math.max(0, quantity + change));
  };

  const handleAddToCart = () => {
    navigate('/login');
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#ffffff',
      fontFamily: 'Poppins, sans-serif'
    }}>
      <FigmaNavigation />
      
      {/* Breadcrumbs - Exact Figma Style */}
      <div style={{
        width: '100%',
        height: '48px',
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '57px',
        gap: '12px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ marginRight: '12px' }}>
            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" stroke="#333" strokeWidth="1.5"/>
          </svg>
        </div>
        <span style={{ fontSize: '16px', fontFamily: 'Poppins', color: '#333' }}>Category</span>
        <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
          <path d="M2 1L6 4L2 7" stroke="#333" strokeWidth="1"/>
        </svg>
        <span style={{ fontSize: '16px', fontFamily: 'Poppins', color: '#333' }}>{product.category}</span>
        <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
          <path d="M2 1L6 4L2 7" stroke="#333" strokeWidth="1"/>
        </svg>
        <span style={{ fontSize: '16px', fontFamily: 'Poppins', color: primaryColor }}>{product.name}</span>
      </div>

      {/* Main Product Section - Exact Figma Dimensions */}
      <div style={{
        width: '1320px',
        margin: '0 auto',
        padding: '32px 96px',
        display: 'flex',
        gap: '24px'
      }}>
        {/* Product Images Section - 649px width from Figma */}
        <div style={{ width: '649px', display: 'flex', gap: '24px' }}>
          {/* Thumbnail Navigation */}
          <div style={{
            width: '80px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '12px'
          }}>
            {/* Up Arrow */}
            <div style={{
              width: '24px',
              height: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              backgroundColor: '#fff'
            }}>
              <svg width="14" height="7" viewBox="0 0 14 7" fill="none">
                <path d="M1 6L7 1L13 6" stroke="#999" strokeWidth="1.5"/>
              </svg>
            </div>
            
            {/* Thumbnail Images */}
            {product.images.map((image, index) => (
              <div
                key={index}
                onClick={() => setSelectedImageIndex(index)}
                style={{
                  width: '80px',
                  height: '90px',
                  borderRadius: '2px',
                  border: selectedImageIndex === index ? `1px solid ${primaryColor}` : '1px solid #e6e6e6',
                  cursor: 'pointer',
                  overflow: 'hidden'
                }}
              >
                <img 
                  src={image}
                  alt={`${product.name} ${index + 1}`}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
              </div>
            ))}
            
            {/* Down Arrow */}
            <div style={{
              width: '24px',
              height: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              backgroundColor: '#fff'
            }}>
              <svg width="14" height="7" viewBox="0 0 14 7" fill="none">
                <path d="M1 1L7 6L13 1" stroke="#999" strokeWidth="1.5"/>
              </svg>
            </div>
          </div>

          {/* Main Product Image */}
          <div style={{
            width: '550px',
            height: '664px',
            backgroundColor: '#f5f5f5',
            borderRadius: '6px',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <img 
              src={product.images[selectedImageIndex]}
              alt={product.name}
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain'
              }}
            />
          </div>
        </div>

        {/* Product Information Section - 647px width from Figma */}
        <div style={{ width: '647px' }}>
          {/* Product Name - Exact Figma Typography */}
          <h1 style={{
            fontSize: '36px',
            fontFamily: 'Poppins',
            fontWeight: '600',
            color: '#1a1a1a',
            lineHeight: '43.2px',
            margin: 0,
            marginBottom: '12px'
          }}>
            {product.name}
          </h1>

          {/* Rating & SKU */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            marginBottom: '20px'
          }}>
            {/* Star Rating */}
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {[1, 2, 3, 4, 5].map((star) => (
                <div key={star} style={{ width: '18px', height: '18px', marginRight: '2px' }}>
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="#FFD700">
                    <path d="M9 1L11.09 6.26L17 7L13 10.74L13.91 16.74L9 14.13L4.09 16.74L5 10.74L1 7L6.91 6.26L9 1Z"/>
                  </svg>
                </div>
              ))}
            </div>
            <span style={{
              fontSize: '14px',
              fontFamily: 'Poppins',
              color: '#666',
              fontWeight: '400'
            }}>
              {product.reviewCount} Review{product.reviewCount !== 1 ? 's' : ''}
            </span>
            <span style={{ fontSize: '14px', color: '#b3b3b3', fontWeight: '500' }}>•</span>
            <span style={{
              fontSize: '14px',
              fontFamily: 'Poppins',
              color: '#333',
              fontWeight: '500'
            }}>
              SKU: {product.sku}
            </span>
          </div>

          {/* Price */}
          <h2 style={{
            fontSize: '24px',
            fontFamily: 'Poppins',
            fontWeight: '500',
            color: '#1a1a1a',
            lineHeight: '36px',
            margin: 0,
            marginBottom: '20px'
          }}>
            ${product.price.toFixed(2)}
          </h2>

          {/* Divider Line */}
          <div style={{
            width: '647px',
            height: '1px',
            backgroundColor: '#e6e6e6',
            marginBottom: '24px'
          }} />

          {/* Pricing Section */}
          <div style={{ marginBottom: '24px' }}>
            <h3 style={{
              fontSize: '18px',
              fontFamily: 'Poppins',
              fontWeight: '500',
              color: '#1a1a1a',
              lineHeight: '27px',
              margin: 0,
              marginBottom: '4px'
            }}>
              Pricing:
            </h3>
            <div style={{ display: 'flex', gap: '45px', alignItems: 'center' }}>
              <div>
                {product.pricingTiers.map((tier, index) => (
                  <div key={index} style={{
                    fontSize: '16px',
                    fontFamily: 'Poppins',
                    fontWeight: '500',
                    color: '#1a1a1a',
                    lineHeight: '24px'
                  }}>
                    {tier.range}
                  </div>
                ))}
              </div>
              <div>
                {product.pricingTiers.map((tier, index) => (
                  <div key={index} style={{
                    fontSize: '16px',
                    fontFamily: 'Poppins',
                    fontWeight: '500',
                    color: '#1a1a1a',
                    lineHeight: '24px'
                  }}>
                    {tier.price}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Sizing */}
          <div style={{ marginBottom: '24px' }}>
            <h3 style={{
              fontSize: '18px',
              fontFamily: 'Poppins',
              fontWeight: '500',
              color: '#1a1a1a',
              lineHeight: '27px',
              margin: 0,
              marginBottom: '4px'
            }}>
              Sizing:
            </h3>
            <div style={{
              fontSize: '16px',
              fontFamily: 'Poppins',
              fontWeight: '500',
              color: '#1a1a1a',
              lineHeight: '24px'
            }}>
              {product.sizing}
            </div>
          </div>

          {/* Shipping */}
          <div style={{ marginBottom: '24px' }}>
            <h3 style={{
              fontSize: '18px',
              fontFamily: 'Poppins',
              fontWeight: '500',
              color: '#1a1a1a',
              lineHeight: '27px',
              margin: 0,
              marginBottom: '4px'
            }}>
              Shipping:
            </h3>
            <div style={{
              fontSize: '16px',
              fontFamily: 'Poppins',
              fontWeight: '500',
              color: '#1a1a1a',
              lineHeight: '24px'
            }}>
              {product.shipping}
            </div>
          </div>

          {/* CTA Section - Exact Figma Style */}
          <div style={{
            width: '647px',
            height: '87px',
            padding: '18px 0',
            backgroundColor: '#ffffff',
            borderTop: '1px solid #e5e5e5',
            borderBottom: '1px solid #e5e5e5',
            boxShadow: '0px 1px 0px 0px #e5e5e5, 0px -1px 0px 0px #e5e5e5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px',
            marginBottom: '24px'
          }}>
            {/* Quantity Selector - Exact Figma Style */}
            <div style={{
              width: '124px',
              height: '50px',
              padding: '8px',
              backgroundColor: '#ffffff',
              borderRadius: '170px',
              border: '1px solid #e6e6e6',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              {/* Minus Button */}
              <div 
                onClick={() => handleQuantityChange(-1)}
                style={{
                  width: '34px',
                  height: '34px',
                  backgroundColor: '#f2f2f2',
                  borderRadius: '170px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer'
                }}
              >
                <svg width="10" height="2" viewBox="0 0 10 2" fill="none">
                  <path d="M1 1H9" stroke="#333" strokeWidth="1.5"/>
                </svg>
              </div>
              
              {/* Quantity */}
              <span style={{
                width: '40px',
                textAlign: 'center',
                fontSize: '16px',
                fontFamily: 'Poppins',
                fontWeight: '400',
                color: '#1a1a1a'
              }}>
                {quantity}
              </span>
              
              {/* Plus Button */}
              <div 
                onClick={() => handleQuantityChange(1)}
                style={{
                  width: '34px',
                  height: '34px',
                  backgroundColor: '#f2f2f2',
                  borderRadius: '170px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer'
                }}
              >
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M5 1V9M1 5H9" stroke="#333" strokeWidth="1.5"/>
                </svg>
              </div>
            </div>

            {/* Add to Cart Button - Exact Figma Style */}
            <button
              onClick={handleAddToCart}
              style={{
                width: '511px',
                height: '51px',
                padding: '16px 40px',
                backgroundColor: primaryColor,
                borderRadius: '43px',
                border: 'none',
                color: 'white',
                fontSize: '16px',
                fontFamily: 'Poppins',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '16px'
              }}
              onMouseEnter={(e) => e.target.style.opacity = '0.9'}
              onMouseLeave={(e) => e.target.style.opacity = '1'}
            >
              Add to Cart
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
                <rect x="1" y="1" width="13" height="13" rx="2" stroke="white" strokeWidth="1.3"/>
              </svg>
            </button>
          </div>

          {/* Feature Cards - Exact Figma Style */}
          <div style={{
            width: '647px',
            height: '91px',
            padding: '24px 20px',
            backgroundColor: '#ffffff',
            borderRadius: '6px',
            border: '1px solid #e6e6e6',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '30px'
          }}>
            {/* Medical ID Feature */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ width: '32px', height: '32px' }}>
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M16 4L20 12H28L22 18L24 28L16 22L8 28L10 18L4 12H12L16 4Z" fill={primaryColor}/>
                </svg>
              </div>
              <div>
                <div style={{
                  fontSize: '14px',
                  fontFamily: 'Poppins',
                  fontWeight: '600',
                  color: '#1a1a1a',
                  lineHeight: '16.8px'
                }}>
                  Medical Identification Number
                </div>
                <div style={{
                  fontSize: '13px',
                  fontFamily: 'Poppins',
                  fontWeight: '400',
                  color: '#333',
                  lineHeight: '19.5px'
                }}>
                  Required for Purchase
                </div>
              </div>
            </div>

            {/* Discount Feature */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ width: '32px', height: '32px' }}>
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M16 4L20 12H28L22 18L24 28L16 22L8 28L10 18L4 12H12L16 4Z" fill={primaryColor}/>
                </svg>
              </div>
              <div>
                <div style={{
                  fontSize: '14px',
                  fontFamily: 'Poppins',
                  fontWeight: '600',
                  color: '#1a1a1a',
                  lineHeight: '16.8px'
                }}>
                  Get 5% Off Purchase Price
                </div>
                <div style={{
                  fontSize: '13px',
                  fontFamily: 'Poppins',
                  fontWeight: '400',
                  color: '#333',
                  lineHeight: '19.5px'
                }}>
                  On Pay Today Orders
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs Section - Exact Figma Style */}
      <div style={{
        width: '100%',
        backgroundColor: '#fff',
        borderBottom: '1px solid #e5e5e5'
      }}>
        {/* Tab Navigation */}
        <div style={{
          width: '1920px',
          height: '56px',
          padding: '0 689px',
          backgroundColor: '#ffffff',
          boxShadow: '0px 1px 0px 0px #e5e5e5',
          display: 'flex',
          alignItems: 'center',
          margin: '0 auto'
        }}>
          {[
            { label: 'Descriptions', value: 0 },
            { label: 'Additional Information', value: 1 },
            { label: 'Customer Feedback', value: 2 }
          ].map((tab) => (
            <div
              key={tab.value}
              onClick={() => setSelectedTab(tab.value)}
              style={{
                width: tab.value === 0 ? '132px' : '214px',
                height: '56px',
                padding: '16px',
                backgroundColor: '#ffffff',
                borderBottom: selectedTab === tab.value ? `2px solid ${primaryColor}` : 'none',
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer'
              }}
            >
              <span style={{
                fontSize: '16px',
                fontFamily: 'Poppins',
                fontWeight: '500',
                color: selectedTab === tab.value ? '#1a1a1a' : '#4d4d4d',
                lineHeight: '24px'
              }}>
                {tab.label}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div style={{
        width: '1216px',
        margin: '32px auto',
        display: 'flex',
        gap: '32px',
        justifyContent: 'center'
      }}>
        {selectedTab === 0 && (
          <>
            {/* Description Content */}
            <div style={{ width: '648px' }}>
              <div style={{
                fontSize: '16px',
                fontFamily: 'Poppins',
                fontWeight: '500',
                color: '#1a1a1a',
                lineHeight: '24px',
                marginBottom: '20px'
              }}>
                {product.description}
              </div>

              {/* Features List */}
              <div style={{ marginBottom: '20px' }}>
                {product.features.map((feature, index) => (
                  <div key={index} style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginBottom: '14px'
                  }}>
                    {/* Check Circle */}
                    <div style={{
                      width: '20px',
                      height: '20px',
                      backgroundColor: primaryColor,
                      borderRadius: '100px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <svg width="12" height="9" viewBox="0 0 12 9" fill="none">
                        <path d="M1 4L4.5 7.5L11 1" stroke="white" strokeWidth="2"/>
                      </svg>
                    </div>
                    <span style={{
                      fontSize: '16px',
                      fontFamily: 'Poppins',
                      fontWeight: '500',
                      color: '#1a1a1a',
                      lineHeight: '24px'
                    }}>
                      {feature}
                    </span>
                  </div>
                ))}
              </div>

              <div style={{
                fontSize: '16px',
                fontFamily: 'Poppins',
                fontWeight: '500',
                color: '#1a1a1a',
                lineHeight: '24px',
                marginBottom: '20px'
              }}>
                {product.additionalInfo}
              </div>

              {/* Share Section */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <span style={{
                  fontSize: '14px',
                  fontFamily: 'Poppins',
                  fontWeight: '400',
                  color: '#1a1a1a'
                }}>
                  Share item:
                </span>
                <div style={{ display: 'flex', gap: '5px' }}>
                  {/* Facebook */}
                  <div style={{
                    width: '40px',
                    height: '40px',
                    backgroundColor: primaryColor,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer'
                  }}>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="white">
                      <path d="M18 9C18 4.03 13.97 0 9 0C4.03 0 0 4.03 0 9C0 13.49 3.29 17.22 7.59 17.9V11.61H5.31V9H7.59V7.02C7.59 4.79 8.94 3.54 10.92 3.54C11.87 3.54 12.87 3.72 12.87 3.72V5.94H11.77C10.69 5.94 10.35 6.62 10.35 7.32V9H12.78L12.39 11.61H10.35V17.9C14.71 17.22 18 13.49 18 9Z"/>
                    </svg>
                  </div>
                  {/* Twitter */}
                  <div style={{
                    width: '40px',
                    height: '40px',
                    border: '1px solid #e5e5e5',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    backgroundColor: 'white'
                  }}>
                    <svg width="18" height="15" viewBox="0 0 18 15" fill="#666">
                      <path d="M18 1.77C17.37 2.05 16.7 2.23 16 2.3C16.74 1.86 17.3 1.14 17.55 0.3C16.88 0.7 16.12 0.97 15.32 1.09C14.68 0.37 13.74 0 12.69 0C10.67 0 9.04 1.64 9.04 3.65C9.04 3.93 9.07 4.2 9.13 4.46C5.97 4.35 3.17 2.89 1.29 0.67C0.98 1.24 0.8 1.86 0.8 2.54C0.8 3.77 1.42 4.85 2.38 5.47C1.8 5.45 1.26 5.3 0.78 5.04V5.08C0.78 6.84 2.03 8.31 3.68 8.64C3.38 8.72 3.06 8.76 2.73 8.76C2.5 8.76 2.27 8.74 2.06 8.69C2.51 10.14 3.84 11.18 5.42 11.21C4.18 12.17 2.62 12.74 0.93 12.74C0.64 12.74 0.36 12.72 0.08 12.69C1.68 13.71 3.59 14.28 5.64 14.28C12.69 14.28 16.56 8.83 16.56 4.07C16.56 3.91 16.56 3.76 16.55 3.6C17.23 3.1 17.82 2.48 18.28 1.77H18Z"/>
                    </svg>
                  </div>
                  {/* Pinterest */}
                  <div style={{
                    width: '40px',
                    height: '40px',
                    border: '1px solid #e5e5e5',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    backgroundColor: 'white'
                  }}>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="#666">
                      <path d="M9 0C4.03 0 0 4.03 0 9C0 12.75 2.41 15.9 5.8 17.24C5.73 16.39 5.68 15.1 5.9 14.17L6.9 9.75C6.9 9.75 6.64 9.23 6.64 8.45C6.64 7.19 7.39 6.26 8.32 6.26C9.11 6.26 9.5 6.83 9.5 7.52C9.5 8.31 9.02 9.49 8.77 10.58C8.56 11.47 9.21 12.2 10.09 12.2C11.67 12.2 12.89 10.58 12.89 8.22C12.89 6.15 11.42 4.72 8.96 4.72C6.17 4.72 4.54 6.75 4.54 8.29C4.54 9.08 4.83 9.93 5.2 10.39C5.28 10.49 5.29 10.58 5.27 10.69L5.01 11.78C4.98 11.93 4.89 11.96 4.74 11.89C3.65 11.39 2.97 9.82 2.97 8.26C2.97 5.73 4.89 3.48 9.21 3.48C12.65 3.48 15.32 5.86 15.32 8.19C15.32 11.67 13.28 14.44 10.32 14.44C9.43 14.44 8.6 13.99 8.32 13.44L7.69 15.95C7.4 17.01 6.65 18.35 6.14 19.18C7.36 19.73 8.67 20 10 20C14.97 20 19 15.97 19 11C19 4.03 14.97 0 10 0H9Z"/>
                    </svg>
                  </div>
                  {/* Instagram */}
                  <div style={{
                    width: '40px',
                    height: '40px',
                    border: '1px solid #e5e5e5',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    backgroundColor: 'white'
                  }}>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="#666">
                      <path d="M9 1.62C11.4 1.62 11.69 1.63 12.67 1.68C13.58 1.72 14.08 1.87 14.42 1.99C14.89 2.16 15.23 2.37 15.58 2.72C15.93 3.07 16.14 3.41 16.31 3.88C16.43 4.22 16.58 4.72 16.62 5.63C16.67 6.61 16.68 6.9 16.68 9.3C16.68 11.7 16.67 11.99 16.62 12.97C16.58 13.88 16.43 14.38 16.31 14.72C16.14 15.19 15.93 15.53 15.58 15.88C15.23 16.23 14.89 16.44 14.42 16.61C14.08 16.73 13.58 16.88 12.67 16.92C11.69 16.97 11.4 16.98 9 16.98C6.6 16.98 6.31 16.97 5.33 16.92C4.42 16.88 3.92 16.73 3.58 16.61C3.11 16.44 2.77 16.23 2.42 15.88C2.07 15.53 1.86 15.19 1.69 14.72C1.57 14.38 1.42 13.88 1.38 12.97C1.33 11.99 1.32 11.7 1.32 9.3C1.32 6.9 1.33 6.61 1.38 5.63C1.42 4.72 1.57 4.22 1.69 3.88C1.86 3.41 2.07 3.07 2.42 2.72C2.77 2.37 3.11 2.16 3.58 1.99C3.92 1.87 4.42 1.72 5.33 1.68C6.31 1.63 6.6 1.62 9 1.62ZM9 0C6.55 0 6.25 0.01 5.26 0.06C4.27 0.11 3.6 0.28 3.02 0.53C2.42 0.78 1.9 1.13 1.39 1.64C0.88 2.15 0.53 2.67 0.28 3.27C0.03 3.85 -0.14 4.52 -0.09 5.51C-0.04 6.5 -0.03 6.8 -0.03 9.25C-0.03 11.7 -0.04 12 -0.09 12.99C-0.14 13.98 0.03 14.65 0.28 15.23C0.53 15.83 0.88 16.35 1.39 16.86C1.9 17.37 2.42 17.72 3.02 17.97C3.6 18.22 4.27 18.39 5.26 18.44C6.25 18.49 6.55 18.5 9 18.5C11.45 18.5 11.75 18.49 12.74 18.44C13.73 18.39 14.4 18.22 14.98 17.97C15.58 17.72 16.1 17.37 16.61 16.86C17.12 16.35 17.47 15.83 17.72 15.23C17.97 14.65 18.14 13.98 18.09 12.99C18.14 12 18.15 11.7 18.15 9.25C18.15 6.8 18.14 6.5 18.09 5.51C18.14 4.52 17.97 3.85 17.72 3.27C17.47 2.67 17.12 2.15 16.61 1.64C16.1 1.13 15.58 0.78 14.98 0.53C14.4 0.28 13.73 0.11 12.74 0.06C11.75 0.01 11.45 0 9 0Z"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            {/* Video Section */}
            <div style={{ width: '536px', height: '345px' }}>
              <div style={{
                width: '536px',
                height: '345px',
                padding: '125px 243px',
                borderRadius: '6px',
                backgroundColor: '#f8f9fa',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <div style={{
                  width: '50px',
                  height: '50px',
                  backgroundColor: primaryColor,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer'
                }}>
                  <svg width="14" height="18" viewBox="0 0 14 18" fill="white">
                    <path d="M1 1L13 9L1 17V1Z"/>
                  </svg>
                </div>
              </div>
            </div>
          </>
        )}

        {/* Additional Information Tab */}
        {selectedTab === 1 && (
          <div style={{ width: '648px' }}>
            <div style={{
              fontSize: '16px',
              fontFamily: 'Poppins',
              fontWeight: '500',
              color: '#1a1a1a',
              lineHeight: '24px'
            }}>
              Additional product information and specifications will be displayed here.
            </div>
          </div>
        )}

        {/* Customer Feedback Tab */}
        {selectedTab === 2 && (
          <div style={{ width: '648px' }}>
            <div style={{
              fontSize: '16px',
              fontFamily: 'Poppins',
              fontWeight: '500',
              color: '#1a1a1a',
              lineHeight: '24px'
            }}>
              Customer reviews and feedback will be displayed here.
            </div>
          </div>
        )}
      </div>

      {/* Related Products Section */}
      <div style={{
        width: '1320px',
        margin: '32px auto',
        marginBottom: '32px'
      }}>
        <h2 style={{
          fontSize: '32px',
          fontFamily: 'Poppins',
          fontWeight: '600',
          color: '#1a1a1a',
          lineHeight: '38.4px',
          textAlign: 'center',
          marginBottom: '32px'
        }}>
          Related Products
        </h2>
        
        <div style={{
          display: 'flex',
          gap: '24px',
          justifyContent: 'center'
        }}>
          {/* Related Product Cards */}
          {[1, 2, 3].map((index) => (
            <div key={index} style={{
              width: '312px',
              height: '407px',
              backgroundColor: '#ffffff',
              borderRadius: '8px',
              border: '1px solid #e6e6e6',
              position: 'relative'
            }}>
              {/* Product Image */}
              <div style={{
                width: '312px',
                height: '312px',
                padding: '5px',
                backgroundColor: '#b4ccb4',
                position: 'relative'
              }}>
                <img 
                  src="/UnisynHub/Assets/lipoderma-card.png"
                  alt="Product"
                  style={{
                    width: '302px',
                    height: '302px',
                    objectFit: 'cover'
                  }}
                />
                {/* NEW Tag */}
                {index === 1 && (
                  <div style={{
                    position: 'absolute',
                    top: '16px',
                    left: '16px',
                    padding: '3px 8px',
                    backgroundColor: '#13cdbe',
                    borderRadius: '4px'
                  }}>
                    <span style={{
                      fontSize: '14px',
                      fontFamily: 'Poppins',
                      fontWeight: '400',
                      color: 'white'
                    }}>
                      NEW
                    </span>
                  </div>
                )}
              </div>
              
              {/* Product Info */}
              <div style={{
                width: '312px',
                height: '95px',
                padding: '16px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                gap: '6px'
              }}>
                <div>
                  <div style={{
                    fontSize: '14px',
                    fontFamily: 'Poppins',
                    fontWeight: '400',
                    color: index === 2 ? '#0b6b62' : '#4d4d4d',
                    lineHeight: '21px'
                  }}>
                    Item
                  </div>
                  <div style={{
                    fontSize: '16px',
                    fontFamily: 'Poppins',
                    fontWeight: '500',
                    color: '#1a1a1a',
                    lineHeight: '24px'
                  }}>
                    Item Name
                  </div>
                </div>
                
                {/* Rating & Add to Cart */}
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}>
                  {/* Stars */}
                  <div style={{ display: 'flex' }}>
                    {[1, 2, 3, 4, 5].map((star) => (
                      <div key={star} style={{ width: '12px', height: '12px' }}>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="#FFD700">
                          <path d="M6 0.5L7.5 4.5H11.5L8.5 7L9.5 11L6 8.5L2.5 11L3.5 7L0.5 4.5H4.5L6 0.5Z"/>
                        </svg>
                      </div>
                    ))}
                  </div>
                  
                  {/* Add to Cart Button */}
                  <div style={{
                    width: '40px',
                    height: '40px',
                    backgroundColor: index === 2 ? primaryColor : '#f2f2f2',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer'
                  }}>
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
                      <rect x="1" y="1" width="13" height="13" rx="2" stroke={index === 2 ? "white" : "#1a1a1a"} strokeWidth="1.3"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FigmaProductDetail;
